import { MICROSOFT_CALENDAR_TYPE } from '../../../utils/canCreateRequestWithPersonalCalendar';
/**
 * `microsoft_365` only — `microsoft_ews` (Exchange) is a known, accepted gap;
 * do not widen this to `startsWith('microsoft')`.
 */
export function isMicrosoftManagedRemoteType(remoteType) {
    return remoteType === MICROSOFT_CALENDAR_TYPE;
}
